import { UnitCategory } from "../types/UnitCategories";
import { Get } from "../utils/Api";

export const GetUnitCategories = (accessKey: string, companyId: string) =>
  Get<UnitCategory[]>(accessKey, `/v1/companies/${companyId}/unit-categories`);
